import NotFoundPage from "@page/not-found";
import { getCompanyInfoBySubdomain } from "@service/user";
import { Company } from "@type/company";
import { removeCookie, setCookie } from "@util/cookie";
import { createContext, useContext, useEffect, useState } from "react";

export const SubdomainContext = createContext<[boolean, Company | undefined]>([
    false,
    undefined,
]);

export const useCompanySubdomain = () => {
    return useContext(SubdomainContext);
}

interface Props {
    subdomain: string;
    children: React.ReactNode;
}

function SubdomainProvider(props: Props) {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isNotFound, setNotFound] = useState<boolean>(false);
    const [companyInfo, setCompanyInfo] = useState<Company | undefined>(undefined);

    useEffect(() => {
        if (props.subdomain !== "" && props.subdomain !== "app") {
            getCompanyInfoBySubdomain(props.subdomain)
                .then((resp) => {
                    if (resp.status !== 200) {
                        setCompanyInfo(undefined);
                        return;
                    }
                    setCompanyInfo(resp.data.data);
                    setCookie("CURRENT_COMPANY", props.subdomain);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        setNotFound(true);
                    } else {
                        setCompanyInfo(undefined);
                    }
                }).finally(() => {
                    setLoading(false);
                });
        } else {
            removeCookie("CURRENT_COMPANY");
        }
    }, [])

    return (
        <SubdomainContext.Provider value={[isLoading, companyInfo]}>
            {isNotFound ? (
                <NotFoundPage />
            ) : (
                <>
                    {props.children}
                </>
            )}
        </SubdomainContext.Provider>
    );
}

export default SubdomainProvider